module.exports = __webpack_public_path__ + "img/border.9a3a48b.png";